import React from 'react';
import { Reveal } from './Section';
import { PackagePicker } from './PackagePicker';
import { Leaf } from './Leaf';
export function FinalCTA() {
  return <section id="packages" className="relative w-full overflow-hidden bg-forest-deep px-6 py-16 text-ivory md:px-10 md:py-20 lg:px-16" data-id="element-101" data-mp="3uei2bfyfzq2c">
      <Leaf className="pointer-events-none absolute -left-6 top-10 h-72 w-44 rotate-12 text-ivory/5" data-id="element-102" data-mp="84nugsfhntuy" />
      <Leaf className="pointer-events-none absolute -right-6 bottom-0 h-72 w-44 -rotate-12 text-ivory/5" data-id="element-103" data-mp="m4f0a5vuq3xv" />

      <div className="mx-auto max-w-3xl text-center" data-id="element-104" data-mp="h6n9xgauupvs">
        <Reveal data-id="element-105" data-mp="h414pnbfsmgq">
          <h2 className="font-serif text-4xl font-medium leading-tight text-ivory sm:text-5xl lg:text-6xl" data-id="element-106" data-mp="vui5d4g8z8ck">
            Wellness starts with one sachet.
          </h2>
          <p className="mt-5 font-serif text-xl italic text-sage" data-id="element-107" data-mp="qwgjkbrfsuxe">
            One minute. Every morning. Every day.
          </p>
        </Reveal>

        <Reveal delay={0.15} data-id="element-108" data-mp="zwv77hrvim42">
          <div className="mt-10 rounded-3xl border border-ivory/15 bg-forest/30 p-5 sm:p-6" data-id="element-109" data-mp="zxy01v8raymm">
            <PackagePicker compact data-id="element-110" data-mp="2c5y9blu6mfcu" />
          </div>
        </Reveal>
      </div>
    </section>;
}